// Tours booked on WhatsApp only (no online deposit)
export default {
  whatsappOnly: {
    badge: 'Reserva pelo WhatsApp',
    note: 'Este passeio é reservado diretamente com a nossa equipe pelo WhatsApp. Confirmamos a disponibilidade e combinamos o pagamento com você — sem pagamento antecipado pelo site.',
    reserve: 'Reservar pelo WhatsApp',
    secure: 'Sem pagamento pelo site: nossa equipe confirma tudo com você pelo WhatsApp.',
    cartNote: 'Este pedido é confirmado pelo WhatsApp: nossa equipe verifica a disponibilidade e combina o pagamento com você.',
    cartMixed: 'Seu carrinho tem passeios reservados somente pelo WhatsApp, então todo o pedido será confirmado por lá.',
    stepConfirm: 'WhatsApp',
    formLead: 'Preencha seus dados e enviaremos a reserva completa para a nossa equipe pelo WhatsApp.',
    submit: 'Confirmar reserva pelo WhatsApp',
    submitHint: 'O WhatsApp abre com passeio, data, participantes e seus dados já preenchidos.',
  },
};
